/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { Text } from 'hocs/localization'
import HomeLayout from 'apps/HomeLayout'
import SignUpForm from 'apps/Profile/SignUpForm'
import CreateProfileProgress from 'apps/Profile/CreateProfileProgress'
import SelectedPlan from 'apps/Profile/SelectedPlan'
import * as styles from './CreateProfile.scss'

const cx = classNames.bind(styles)

interface IProps {
  name: string,
  t: Text,
  onCheckBillingBlock: () => void,
  plan: { name: string, id: string }
}

const CreateProfile: React.SFC<IProps> = ({ t, plan }) => (
  <HomeLayout>
    <div className={styles.createProfile}>
      <div className={cx('container', styles.container768)}>
        <div className='row no-gutters'>
          <CreateProfileProgress step={'signUp'} />
        </div>
          <div className={cx('row', 'no-gutters', styles.topSpace50)}>
            <div className='col-md-12 text-center'>
              <div className={styles.selectedPlan}>
                <h2>{t('selectedPlanTitle')}</h2>
              </div>
            </div>
            {plan && <SelectedPlan plan={plan} />}
            <div className={cx('col-md-12', 'text-center', styles.topSpace50)}>
              <div className={styles.selectedPlan}>
                <h2>{t('createAccountTitle')}</h2>
              </div>
              <SignUpForm/>
            </div>
          </div>
      </div>
    </div>
  </HomeLayout>
)

export default CreateProfile
